import React from 'react';
import TrackList from "../Tracklist/TrackList";
import './SearchResult.css';

function SearchResult({tracks, onAdd, }) {

    return (
        <div className="SearchResult">
            <h2>Results</h2>
            <TrackList tracks={tracks} onAdd={onAdd} isRemoevable={false} />
        </div>
    )
}

export default SearchResult;